import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// import { SignupComponent } from './signup/signup.component';
import { SigninComponent } from './signin/signin.component';
import { HomeComponent } from '../core/home/home.component'

// signUp is removed and instead users would be redirected to HomePage even if they try to type signup by hand.
const authRoutes: Routes = [
  { path: 'signup', component: HomeComponent },
  { path: 'signin', component: SigninComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(authRoutes)
  ],
  exports: [RouterModule]
})
export class AuthRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/auth/auth-routing.module.ts